import styled from 'styled-components';

import { Dot } from './dot';

type Size = 'sm' | 'md' | 'lg';

interface Props {
  size?: Size;
  color?: string;
}

const getSize = (size?: Size): number => {
  switch (size) {
    case 'sm':
      return 0.25;
    case 'md':
      return 0.75;
    case 'lg':
      return 1;
    default:
      return 0.75;
  }
};

export const Rectangle = styled(Dot)`
  width: ${(props: Props) => `${getSize(props.size) * 3}em`};
  height: ${(props: Props) => `${getSize(props.size)}em`};
  background: ${(props: Props) => props.color || 'gray'};
  border-radius: 2px;
  margin-top: 0.05rem;
`;
